<template>
  <div v-show="visible" class="sticker-action-portal">
    <div class="sticker-action-mask" @click="$emit('close')"></div>
    <div class="sticker-action-card" :style="cardStyle" @click.stop>
      <div class="sticker-action-preview">
        <img :src="url" alt="" />
      </div>
      <div class="sticker-action-divider"></div>
      <div v-if="kind === 'mine'" class="sticker-action-row">
        <button type="button" class="sticker-action-btn" @click="$emit('pin')">移到前面</button>
        <span class="sticker-action-vline"></span>
        <button type="button" class="sticker-action-btn" @click="$emit('remove')">删除</button>
      </div>
      <div v-else class="sticker-action-row">
        <button type="button" class="sticker-action-btn" @click="$emit('add')">添加表情</button>
      </div>
    </div>
  </div>
</template>

<script>
const CARD_WIDTH = 160
const CARD_HEIGHT = 176

export default {
  name: 'StickerActionCard',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    kind: {
      type: String,
      default: 'mine'
    },
    url: {
      type: String,
      default: ''
    },
    anchor: {
      type: Object,
      default: null
    }
  },
  computed: {
    cardStyle() {
      const winW = window.innerWidth
      const winH = window.innerHeight
      const pad = 12
      const gap = 8
      const rect = this.anchor || {
        left: (winW - CARD_WIDTH) / 2,
        top: winH * 0.4,
        width: 0,
        height: 0
      }
      let left = rect.left + rect.width / 2 - CARD_WIDTH / 2
      left = Math.max(pad, Math.min(left, winW - CARD_WIDTH - pad))
      let top = rect.top - CARD_HEIGHT - gap
      if (top < pad) {
        top = rect.top + rect.height + gap
      }
      if (top + CARD_HEIGHT > winH - pad) {
        top = Math.max(pad, winH - CARD_HEIGHT - pad)
      }
      return {
        left: left + 'px',
        top: top + 'px',
        width: CARD_WIDTH + 'px'
      }
    }
  },
  mounted() {
    if (this.$el && this.$el.parentNode !== document.body) {
      document.body.appendChild(this.$el)
    }
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style lang="scss" scoped>
.sticker-action-portal {
  position: fixed;
  inset: 0;
  z-index: 5000;
  pointer-events: none;
}

.sticker-action-mask {
  position: absolute;
  inset: 0;
  pointer-events: auto;
}

.sticker-action-card {
  position: absolute;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.16);
  overflow: hidden;
  pointer-events: auto;
}

.sticker-action-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 18px 14px;

  img {
    width: 100px;
    height: 100px;
    object-fit: contain;
  }
}

.sticker-action-divider {
  height: 1px;
  background: #f0f0f0;
  transform: scaleY(0.5);
}

.sticker-action-row {
  display: flex;
  align-items: stretch;
  min-height: 44px;
}

.sticker-action-btn {
  flex: 1;
  border: 0;
  background: transparent;
  color: #888;
  font-size: 14px;
  line-height: 1.2;
  cursor: pointer;
  padding: 12px 6px;

  &:hover,
  &:active {
    background: #f5f5f5;
  }
}

.sticker-action-vline {
  width: 1px;
  background: #f0f0f0;
  margin: 10px 0;
}
</style>
